import { Grid, Typography } from '@mui/material';
import { deDE } from '@mui/x-data-grid';
import { useId } from 'react';
import { IDocument } from '../../../../../Interfaces/IDocument';
import { CustomeSlide } from '../../../../core/CustomeSlide';
import { useDialogContext } from '../../../../core/DialogPresenter/DialogContext';
import { useRegisterDialogPage } from '../../../../core/DialogPresenter/useRegisterDialogPage';
import { CrudDataGrid } from '../../generic/CrudDataGrid';
import { NavRow } from '../../generic/NavRow';
import { RelationshipDocumentUpload } from '../../generic/RelationshipDocumentUpload';

type ITestamentUploadTestamentsProps = {
  documents: IDocument[];
  setDocuments: React.Dispatch<React.SetStateAction<IDocument[]>>;
};

export function TestamentUploadTestaments({
  documents,
  setDocuments,
}: ITestamentUploadTestamentsProps) {
  const id = useId();
  const { handleNext, handleBack } = useDialogContext();

  const pageNumber = useRegisterDialogPage(id, {
    title: 'Testament(e) hochladen',
  });

  return pageNumber === null ? null : (
    <CustomeSlide key={id} pageNumber={pageNumber} appear={false}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h4' sx={{ mb: 2 }}>
            Testament(e) hochladen
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography>
            Falls Sie bereits ein Testament oder einen Erbvertrag erstellt
            haben, können Sie die entsprechenden Dokumente hier hochladen.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Grid item xs={12}>
            <RelationshipDocumentUpload
              documents={documents}
              setDocuments={setDocuments}
            />
          </Grid>
          <Grid item xs={12}>
            <CrudDataGrid<IDocument>
              sx={{ mt: 2 }}
              autoHeight
              localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5]}
              disableRowSelectionOnClick
              onClickDelete={idDocument => {
                setDocuments(prevDocuments =>
                  prevDocuments.filter(
                    document => document.idDocument !== idDocument
                  )
                );
              }}
              rows={documents}
              columns={[
                {
                  field: 'FileName',
                  headerName: 'Dateiname',
                  flex: 1,
                },
              ]}
              getRowId={row => row.idDocument}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <NavRow handleNext={handleNext} handleBack={handleBack} />
        </Grid>
      </Grid>
    </CustomeSlide>
  );
}
